var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_387)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.238 16.044C18.652 15.182 16.75 16.32 16.75 18.033V31.967C16.75 33.681 18.652 34.818 20.238 33.956L33.05 26.989C34.65 26.119 34.65 23.881 33.05 23.012L20.238 16.044ZM15.25 18.033C15.25 15.128 18.417 13.346 20.955 14.727L33.767 21.694C36.411 23.132 36.411 26.868 33.767 28.306L20.955 35.273C18.417 36.653 15.25 34.873 15.25 31.967V18.033Z",
    fill: "url(#paint0_linear_170_387)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_170_387)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "url(#paint1_linear_170_387)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.238 16.044C18.652 15.182 16.75 16.32 16.75 18.033V31.967C16.75 33.681 18.652 34.818 20.238 33.956L33.05 26.989C34.65 26.119 34.65 23.881 33.05 23.012L20.238 16.044ZM15.25 18.033C15.25 15.128 18.417 13.346 20.955 14.727L33.767 21.694C36.411 23.132 36.411 26.868 33.767 28.306L20.955 35.273C18.417 36.653 15.25 34.873 15.25 31.967V18.033Z",
    fill: "url(#paint2_linear_170_387)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "url(#paint3_linear_170_387)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_170_387",
    x: -3,
    y: -3,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_170_387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_387",
    x1: 25.5,
    y1: 14.251,
    x2: 25.5,
    y2: 35.7488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.221154,
    stopColor: "#0AC0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543269,
    stopColor: "#067192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769231,
    stopColor: "#0AC0F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_170_387",
    x1: -0.842697,
    y1: 28.4161,
    x2: 51.0304,
    y2: 28.3032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#2A75E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572115,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796486,
    stopColor: "#2A75E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_170_387",
    x1: 25.5,
    y1: 14.251,
    x2: 25.5,
    y2: 35.7488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.221154,
    stopColor: "#0AC0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543269,
    stopColor: "#067192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769231,
    stopColor: "#0AC0F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_170_387",
    x1: 0.833333,
    y1: 9.16667,
    x2: 41.5391,
    y2: 42.6551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2A75E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#9235D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644231,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.774038,
    stopColor: "#2A75E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971154,
    stopColor: "#9235D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.c4a9dbae453846b0940cc1518e57a8c5.svg";
export { ForwardRef as ReactComponent };